import React, { PureComponent } from "react";
import Table from "js/components/Shared/Tabla";
import advancedFilter from "js/components/TablaClienteRetail/advancedFilter.js";
import AppQraphQL from "js/graphql/resolvers/clienteRetail.resolver";
import AppQraphQLImport from "js/graphql/resolvers/importar.resolver";
import { editAction } from "js/components/Shared/Tabla/ActionCells";
import { USER_ROLES as Roles } from "js/models/User";
import { Estado } from "js/components/Shared/Tabla/TableCells";
import capitalize from "lodash/capitalize";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import ShareIcon from "@material-ui/icons/Share";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import Store from "@material-ui/icons/Store";

const defaultHeader = (id, btnsNextTitle) => {
  return {
    title: "Clientes Retail",
    btnsNextTitle,
    new: {
      title: "Nuevo",
      perms: [Roles.CLIENTE_RETAIL_W]
    },
    export: {
      path: "clientesRetail",
      perms: [Roles.CLIENTE_RETAIL_R, Roles.CLIENTE_RETAIL_EXPORT],
      tooltip: "Exportar clientes retail"
    },
    import: {
      action: AppQraphQLImport.queries.importarClientesRetail,
      perms: [Roles.CLIENTE_RETAIL_W, Roles.CLIENTE_RETAIL_IMPORT],
      tooltip: "Importar clientes retail",
      model: "Modelo_Clientes_Retail.csv",
      modelTooltip: "Modelo de importación de clientes retail",
      variables: {
        idPrograma: id
      }
    },
    queryStringMatcher: {
      idsPrograma: undefined
    }
  };
};
const columnData = [
  { id: "fechaCreacion", label: "Fecha Creación", type: "date" },
  { id: "nombre", label: "Nombre" },
  { id: "documento", label: "Documento" },
  { id: "telefono", label: "Teléfono" },
  { id: "email", label: "Email" },
  {
    id: "estado",
    label: "Estado",
    type: "custom",
    parser: estado => <Estado estado={capitalize(estado)} />
  },
  { id: "actions", label: "Acciones" }
];

const defaultSort = { order: "desc", orderBy: "fechaCreacion" };

class Tabla extends PureComponent {
  render() {
    const {
      match: {
        params: { id }
      }
    } = this.props;

    const edit = params => ({
      ...editAction({
        ...params,
        history: this.props.history,
        perms: [Roles.CLIENTE_RETAIL_W]
      })
    });

    const btnsNextTitle = [];
    btnsNextTitle.push({
      btn: (
        <Tooltip title="Productos">
          <IconButton
            color="primary"
            onClick={() =>
              this.props.history.push(`/admin/programa/${id}/productos-retail`)
            }
          >
            <Store />
          </IconButton>
        </Tooltip>
      ),
      perms: [Roles.PRODUCTO_RETAIL_R]
    });
    btnsNextTitle.push({
      btn: (
        <Tooltip title="Ventas">
          <IconButton
            color="primary"
            onClick={() =>
              this.props.history.push(`/admin/programa/${id}/ventas-retail`)
            }
          >
            <AttachMoneyIcon />
          </IconButton>
        </Tooltip>
      ),
      perms: [Roles.VENTA_RETAIL_R]
    });
    btnsNextTitle.push({
      btn: (
        <Tooltip title="Canales">
          <IconButton
            color="primary"
            onClick={() =>
              this.props.history.push(`/admin/programa/${id}/canales-retail`)
            }
          >
            <ShareIcon />
          </IconButton>
        </Tooltip>
      ),
      perms: [Roles.CANAL_RETAIL_R]
    });

    return (
      <Table
        storage={"FiltroClienteRetail"}
        query={AppQraphQL.queries.getClientesRetail}
        defaultHeader={defaultHeader(id, btnsNextTitle)}
        advancedFilter={advancedFilter}
        sort={defaultSort}
        columnData={columnData}
        getTipo={data => data.getClientesRetail}
        actionsCustom={[edit]}
      />
    );
  }
}

export default Tabla;
